// The operator platform is this same dashboard build served on its own
// subdomain: when the page is opened on an operator host, index.tsx renders
// OperatorRoutes (a slim, role-gated shell) instead of the full dashboard.
//
// OPERATOR_HOSTS (comma-separated, injected into index.html like API_URL)
// lists the exact hostnames; when unset, any host starting with "ops." is an
// operator host — e.g. ops.maxcei.pt in production, ops.localhost locally.
export const isOperatorHost = (
  hostname: string = window.location.hostname,
  configuredHosts: string | undefined = window.__SALEOR_CONFIG__?.OPERATOR_HOSTS,
): boolean => {
  const hosts = (configuredHosts ?? "")
    .split(",")
    .map(host => host.trim().toLowerCase())
    .filter(Boolean);

  if (hosts.length > 0) {
    return hosts.includes(hostname.toLowerCase());
  }

  return hostname.toLowerCase().startsWith("ops.");
};
